const changeStatusInputManagementEquip = {
  title: 'INATIVAR EQUIPAMENTOS',
  title2: 'REATIVAR EQUIPAMENTOS',
};

export default changeStatusInputManagementEquip;
